<template>
    <div>
	    <div class="nutnosti-title" > StarNet: </div>

		<div v-if="loading" class="loading">
			<tile :loading="loading" :height="'4'" :width="'4'" class="loading-icon"></tile> 
		</div>

		<div v-else class="nutnosti cetin-vysledek-card zmensit" :style="{ backgroundColor: result.exists ? '#8bfc8d' : '#ff8c8c' }">
			{{ result.exists ? 'Dostupný' : (result.exists === null) ? 'Adresa Nenalezena' : 'Nedostupný' }} <br />
			{{ result.technologie ? result.technologie : 'Bez informace o technologii.'}}
		</div>
	</div>
</template>

<script>
export default {
	name: 'StarNetResult',

	props: {
		result: { type: Object },
		loading: { type: Boolean }
	},
}
</script>

<style lang="stylus" scoped>
.nutnosti
	display flex
	flex-direction column

.nutnosti-title
	margin-top 20px
	font-size 24px
	font-weight bold
	border-top 1px solid #4CA5F9

.cetin-vysledek-card
	padding 10px
	background-color white
	border-radius 5px
	margin-right 10px
	margin-bottom 10px

.zmensit
	width 400px

.loading
	height 50px
	padding 0px

.loading-icon
	height 50px
	padding 0px !important
	margin-top -100px !important

.spinner
	margin-top 0px !important

@media (max-width 1000px)
	.zmensit
		width 100%

</style>



// WEBPACK FOOTER //
// src/components/search_provider/results/StarNetResult.vue